module.exports = __webpack_public_path__ + "static/media/heidi.dfcd4d24.jpg";